// extracted by mini-css-extract-plugin
export default {"parent":"style_parent__d6k7h","child":"style_child__IFSxy"};